<template>
  <v-select
    class="mt-0"
    single-line
    clearable
    :label="label"
    :loading="loading"
    :value="value"
    :disabled="disabled"
    :items="drivers"
    item-text="name"
    item-value="id"
    @change="$emit('change', $event)">
    <template slot="item" slot-scope="data">
      <bqa-certificate-icon small :driver="data.item" />
      {{ data.item.name }}
    </template>
    <template slot="prepend-inner" slot-scope="data">
      <!-- TODO: Ignacio, why isn't this working? I had it working for 10 minutes then it stoped -->
      <bqa-certificate-icon small :driver="data.item" />
    </template>
  </v-select>
</template>

<script>
import { driversWithCDN } from '@/types/models/company';
import BqaCertificateIcon from './BqaCertificateIcon';

export default {
  name: 'VSelectDriver',
  components: { BqaCertificateIcon },
  props: {
    company: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    value: {
      default: null,
    },
    label: {
      default: 'Select Driver',
    },
  },
  computed: {
    drivers() {
      return driversWithCDN(this.company);
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SelectDriver.vue